// extracted by mini-css-extract-plugin
export default {"SmallChartCard":"SmallChartCard_SmallChartCard__z5Ext","TitleCard":"SmallChartCard_TitleCard__gnXnC","imgIndicadorDeshabilitado":"SmallChartCard_imgIndicadorDeshabilitado__jDXxl"};